export const mergeConfig = (base, override = {}) => {

  return {

    components: {

      ...base.components,

      ...(override.components || {})

    },

    fields: {

      ...base.fields,

      ...(override.fields || {})

    },
    variant_fields: {
      required: [
        ...(base.variant_fields?.required || []),
        ...(override.variant_fields?.required || [])
      ],
      optional: [
        ...(base.variant_fields?.optional || []),
        ...(override.variant_fields?.optional || [])
      ]
    },
    table: {
      ...base.table,
      ...override.table
    },
 specifications: [
      ...(base.specifications || []),
      ...(override.specifications || [])
    ]

  };

};